export default __webpack_public_path__ + "images/logo-dark.02e6465f522966e04e8918d2347c3d82.png";